import { DateTime } from 'luxon';
import { Instance, types } from 'mobx-state-tree';

const Report = types
	.model('Report', {
		type: types.maybeNull(types.string),
		subtype: types.maybeNull(types.string),
		pdf_url: types.maybeNull(types.string),
		lang: types.maybeNull(types.string),
		academic_semester_name: types.maybeNull(types.string),
		is_published: types.maybeNull(types.number),
		published_at: types.maybeNull(types.string),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		get dateTime() {
			return DateTime.fromISO(self.published_at);
		},
	}))
	.views((self) => ({
		get dateString() {
			return self.dateTime.toISODate();
		},
	}));

export default Report;

export interface IReportModel extends Instance<typeof Report> {}
